import { openDialog } from '@/_components/dialog/dialog'

export async function initDialog(component, props) {
    return await openDialog(component, props)
}
